<script setup lang="ts">
import { onErrorCaptured, ref } from 'vue'

const emit = defineEmits<{ error: [error: Error, info: string] }>()
const error = ref<Error | null>(null)

onErrorCaptured((captured, _instance, info) => {
  const normalized = captured instanceof Error ? captured : new Error(String(captured))
  console.error('[ErrorBoundary] Captured error:', normalized, info)
  error.value = normalized
  emit('error', normalized, info)
  return false
})

function reset(): void {
  error.value = null
}

defineExpose({ reset })
</script>

<template>
  <slot v-if="!error" />
  <slot v-else name="fallback" :error="error" :reset="reset" />
</template>
